import React from "react";
import {Spin} from "antd";

const Loader = ({fullscreen = false}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: fullscreen ? "100vh" : "100%",
      }}
    >
      <Spin size="large" />
    </div>
  );
};

export default Loader;
